module.exports = __webpack_public_path__ + "img/icon-homepage-country-arrow-close.038f40d.svg";